import React from 'react'
import { Col } from 'react-bootstrap'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTintSlash } from '@fortawesome/free-solid-svg-icons'

const PageNotFound = () => {
  return (
    <Col className="text-center align-self-center mt-5">
      <FontAwesomeIcon
        size="10x"
        icon={faTintSlash}
        color="lightgray"
        className="mb-5"
      />
      <h1 className="text-secondary font-weight-light">Página no encontrada</h1>
      <hr className="w-50" />
      <p className="text-black-50 font-weight-lighter">
        Lo sentimos, esta página no existe.
      </p>
    </Col>
  )
}

export default PageNotFound
